import { RoutePath } from "#src/utils/route";
import { FormsRoute } from "..";

export const linkToFormCategoryList = () => {
  return "/app/forms/categories";
};

export const FORMS_CATEGORIES_BREADCRUMB = {
  title: "Categories",
  path: linkToFormCategoryList,
};

export const FormCategoriesRoute = FormsRoute.concat(
  new RoutePath({
    path: "/categories",
    title: "Categories",
  })
);
